import { createSlice } from "@reduxjs/toolkit";

const initialState = () => {
  const savedState = JSON.parse(localStorage.getItem("genre"));
  return (
    savedState || {
      genre: ["Fiction", "Kids", "YoungAdult", "SelfHelp", "NonFiction"],
    }
  );
};

const genreState = createSlice({
  name: "GenreSate",
  initialState: initialState(),
  reducers: {
    addGenre(state, action) {
      if (action.payload) {
        state.genre.push(action.payload);
        localStorage.setItem("genre", JSON.stringify(state));
      }
    },
  },
});

export const { addGenre } = genreState.actions;
export const genreReducer = genreState.reducer;
